var validateSpine = require ("./dist/spine-validator");

module.exports = validateSpine;


//////////////////
// WEBPACK FOOTER
// /opt/app/util/spine-validator/validator.js
// module id = ../../../../../../util/spine-validator/validator.js
// module chunks = 0